export const PURCHASE_INVOICE_WEEK_FORMAT = "yyyy-w"
export const PURCHASE_INVOICE_DATE_GRANULARITY = "week"
